import { requestPost } from '@utils/httpService';
import { create } from 'zustand';

const useDonateDialogStore = create((set) => ({
  open: false,
  nonProfit: null,
  amount: 0,
  post: null,
  setOpen: (
    isOpen,
    data = {
      nonProfit: null,
      amount: '',
      post: null,
    },
  ) =>
    set(() => ({
      open: isOpen,
      nonProfit: data.nonProfit,
      amount: data.amount,
      post: data.post,
    })),
}));

export default useDonateDialogStore;
